// ヘッダースクロールすると背景色変更
$(function () {
  $(window).on("scroll", function () {
    const sliderHeight = $(".mv").height();
    if (sliderHeight - 30 < $(this).scrollTop()) {
      $(".js-header").addClass("headerColorScroll");
    } else {
      $(".js-header").removeClass("headerColorScroll");
    }
  });
});

// アンカーリンク押したらナビ閉じる
if (window.innerWidth <= 768) {
    $('.header_nav a[href]').on('click', function(event) {
        $('.menu-trigger').trigger('click');
    });
}

// 動きのきっかけの起点となるアニメーションの名前を定義
function fadeAnime(){

// ふわっ
$('.fadeUpTrigger').each(function(){ //fadeUpTriggerというクラス名が
var elemPos = $(this).offset().top+200;//要素より、200px下から表示させる
var scroll = $(window).scrollTop();
var windowHeight = $(window).height();
if (scroll >= elemPos - windowHeight){
$(this).addClass('fadeUp');// 画面内に入ったらfadeUpというクラス名を追記
}else{
$(this).removeClass('fadeUp');// 画面外に出たらfadeUpというクラス名を外す
}
});
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述


//スクロールが100に達したらTOPへ戻るボタン表示	
$(function(){
	var topBtn = $('#pagetop');    
	topBtn.hide();
    
	 
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
		
	 //スクロールフェードイン
		if ($(this).scrollTop() > 100) {
		}
    });
	  $(window).scroll(function (){
    $('.fadein').each(function(){
        var elemPos = $(this).offset().top,
            scroll = $(window).scrollTop(),
            windowHeight = $(window).height();
          if (scroll > elemPos - windowHeight + 100){
              $(this).addClass('scrollin');
            }
        });
	});
	
	// スクロールメニュー
	 $("#pagetop").click(function(e){
		$('body,html').animate({scrollTop: 0});
	 });
	 
	 $(window).resize(windwRisizeHandler);
	 windwRisizeHandler();
 });

// スワイパー
$(function(){
var mySwiper = new Swiper('.swiper-container', {
	loop: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true
	 }
  });
});

// FAQアコーディオン
$(function(){
$(".qa-list dd").hide();
$(".qa-list dl").on("click", function(e){
    $('dd',this).slideToggle('fast');
    if($(this).hasClass('open')){
        $(this).removeClass('open');
    }else{
        $(this).addClass('open');
    }
  });
});

